var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { NonVisualInfo, StepBase, StepLabel, StepList, StepNode } from './subcomponents';
const Stepper = (_a) => {
    var { className, element, onClick, steps, statusIcon } = _a, props = __rest(_a, ["className", "element", "onClick", "steps", "statusIcon"]);
    return (_jsx(StepBase, Object.assign({}, props, { className: className }, { children: steps.map((step, index) => {
            const { label, status, nonVisualInfo, icon } = step;
            const isLastStep = index === steps.length - 1;
            return (_jsxs(StepList, Object.assign({ "data-testid": `step-list-${label}`, status: status }, { children: [element !== null && element !== void 0 ? element : (_jsx(StepNode, Object.assign({ "data-testid": `step-node-${label}`, status: status, onClick: onClick &&
                            ((e) => onClick(e, index)) }, { children: (statusIcon === null || statusIcon === void 0 ? void 0 : statusIcon[status]) || icon }))), nonVisualInfo && _jsx(NonVisualInfo, { children: nonVisualInfo }), _jsx(StepLabel, Object.assign({ "data-testid": `step-label-${label}`, status: status, "$isLastStep": isLastStep }, { children: label })), step.info] }), label));
        }) })));
};
export default Stepper;
//# sourceMappingURL=Stepper.js.map